export const randomId = () => {
  const min = 100000;
  const max = 1000000; // Exclusive
  return Math.floor(Math.random() * (max - min) + min).toString();
};

export const advancedRandomId = (length: number) => {
  return new Array(length).fill("").map(randomId).join("-");
};

/**
 * Generates a number ID with extremely low collision probability
 * @returns number A unique numeric ID less than 2,147,483,647 (MAX_INT)
 */
export function randomNumberId(): number {
  const array = new Int32Array(1);
  crypto.getRandomValues(array);
  return array[0] || 1;
}

/**
 * `crypto.randomUUID` exists only in a secure context, so on a plain-http preview
 * host or a LAN address it is undefined and calling it throws. `getRandomValues`
 * has no such restriction.
 */
export function randomUuid(): string {
  if (crypto.randomUUID) return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => (byte + 0x100).toString(16).slice(1)).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
